/** @typedef {'booking' | 'vendor' | 'system' | 'success' | 'error' | string} AdminNotificationType */

export const NOTIFICATION_TYPE_META = {
  booking: {
    label: 'Booking',
    icon: 'fa-calendar-check',
    badgeClass: 'bg-blue-100 text-blue-700',
    borderClass: 'border-blue-500',
  },
  vendor: {
    label: 'Vendor',
    icon: 'fa-store',
    badgeClass: 'bg-green-100 text-green-700',
    borderClass: 'border-green-500',
  },
  system: {
    label: 'System',
    icon: 'fa-cog',
    badgeClass: 'bg-amber-100 text-amber-800',
    borderClass: 'border-amber-500',
  },
  success: {
    label: 'Success',
    icon: 'fa-check-circle',
    badgeClass: 'bg-emerald-100 text-emerald-700',
    borderClass: 'border-emerald-500',
  },
  error: {
    label: 'Error',
    icon: 'fa-exclamation-circle',
    badgeClass: 'bg-red-100 text-red-700',
    borderClass: 'border-red-500',
  },
};

/**
 * @param {string | undefined} type
 */
export function getNotificationTypeMeta(type) {
  const key = String(type || 'system').toLowerCase();
  return NOTIFICATION_TYPE_META[key] || NOTIFICATION_TYPE_META.system;
}

/**
 * @param {string | undefined} iso
 */
export function formatNotificationRelativeTime(iso) {
  if (!iso) return 'Just now';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return 'Just now';
  const diffSec = Math.floor((Date.now() - then) / 1000);
  if (diffSec < 60) return 'Just now';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 604800) return `${Math.floor(diffSec / 86400)}d ago`;
  return new Date(iso).toLocaleString();
}

/**
 * @param {import('../../store/notificationStorage').StoredNotification} notification
 */
export function getNotificationTargetMenuId(notification) {
  const type = String(notification?.type || '').toLowerCase();
  const title = String(notification?.title || '').toLowerCase();
  if (title.includes('driver assigned') || title.includes('trip completed') || title.includes('trip started') || title.includes('driver arrived')) {
    return 'bookings';
  }
  if (type === 'booking' || type === 'vendor' || type === 'system') {
    return 'broadcasts';
  }
  if (type === 'error' || type === 'success') {
    return 'bookings';
  }
  return 'bookings';
}
